import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const faqApi = {
  getFaqs: async ({ page = 1, perPage = 10, search = '', includeTrashed = false } = {}) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.FAQS}`, {
        params: { page, per_page: perPage, search, trashed: includeTrashed ? 'true' : 'false' },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching FAQs:', error);
      throw error;
    }
  },

  getFaqByIdentifier: async (identifier) => {
    try {
      const url = `${API_ENDPOINTS.FAQS}/${identifier}`;
      const response = await apiClient.get(url);
      return response.data;
    } catch (error) {
      console.error(`Error fetching FAQ ${identifier}:`, error);
      throw error;
    }
  },

  createFaq: async (faqData) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.FAQS}`, faqData);
      return response.data;
    } catch (error) {
      console.error('Error creating FAQ:', error);
      throw error;
    }
  },

  updateFaq: async (identifier, faqData) => {
    try {
      faqData.append('_method', 'PUT');
      const response = await apiClient.post(`${API_ENDPOINTS.FAQS}/${identifier}`, faqData);
      return response.data;
    } catch (error) {
      console.error(`Error updating FAQ ${identifier}:`, error);
      throw error;
    }
  },

  trashFaq: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.FAQS}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error trashing FAQ ${identifier}:`, error);
      throw error;
    }
  },

  restoreFaq: async (identifier) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.FAQS}/${identifier}/restore`);
      return response.data;
    } catch (error) {
      console.error(`Error restoring FAQ ${identifier}:`, error);
      throw error;
    }
  },

  permanentDeleteFaq: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.FAQS}/${identifier}/permanent-delete`);
      return response.data;
    } catch (error) {
      console.error(`Error permanently deleting FAQ ${identifier}:`, error);
      throw error;
    }
  },
};

export default faqApi;